import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
export function AboutUsPage() {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`} data-id="element-2960">
      <Navbar data-id="element-2961" />
      <div className="pt-20 pb-16" data-id="element-2962">
        <main className="pb-6" data-id="element-2963">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2964">
            <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl shadow-lg p-8 md:p-12`} data-id="element-2965">
              {/* Header */}
              <h1 className={`text-4xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-2966">
                About Us
              </h1>

              {/* Content */}
              <div className={`prose prose-lg max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-2967">
                <div className="space-y-6 text-lg leading-relaxed" data-id="element-2968">
                  <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-2969">
                    Maestro Connect is a modern platform built to simplify and
                    elevate private music education.
                  </p>

                  <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-2970">
                    We help music teachers manage students, lessons, scheduling,
                    tasks, and communication in one clear, professional system —
                    while giving students a focused, structured learning
                    experience.
                  </p>

                  <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-2971">
                    Maestro Connect also enables students and teachers to
                    connect through a shared learning platform designed around
                    real lesson workflows.
                  </p>

                  <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-2972">
                    The platform is designed by musicians, for musicians. We
                    understand the real challenges teachers face: scattered
                    tools, missed lessons, unclear progress tracking, and time
                    lost on administration instead of teaching. Maestro Connect
                    brings everything together so teachers can focus on what
                    matters most — teaching — and students can stay motivated,
                    organized, and progressing.
                  </p>

                  <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-2973">
                    Our mission is to modernize music education without
                    overcomplicating it. Maestro Connect is intentionally clean,
                    practical, and built to grow with teachers, studios, and
                    schools worldwide.
                  </p>

                  <p className={`font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-2974">
                    We're building long-term infrastructure for music education
                    — not just another app.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer data-id="element-2975" />
    </div>;
}